import { FileMinus } from '@phosphor-icons/react'

export function NoData() {
  return (
    <div className='p-4 flex items-center justify-center h-full w-full flex-col'>
      <div className='h-32 w-32 bg-[#F0F0F04D] rounded-full flex items-center justify-center'>
        <div className='h-20 w-20 bg-gray-light rounded-full flex items-center justify-center'>
          <FileMinus size={40} weight='fill' color='#5B5B5B' />
        </div>
      </div>
      <span className='text-sm text-[#4E4E4E] mt-4'>No data to show yet</span>
    </div>
  )
}
